module.exports = __webpack_public_path__ + "img/pragmatic-programmer.71e5989f.jpg";